import { administrationRequests } from "api/administrationApi";
import { studentRequests } from "api/studentApi";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";
import React, { useEffect } from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";

const SessionStartUnpassedExamsCount = ({ handleParamChange }) => {
  const { setValue } = useFormContext();
  const structuralUnitId = useWatch({ name: "structuralUnitId" });
  const specialityId = useWatch({ name: "specialityId" });

  // Reset the discipline whenever the speciality changes.
  useEffect(() => {
    setValue("disciplineId", null);
    handleParamChange("disciplineId", null);
  }, [specialityId, setValue, handleParamChange]);

  return (
    <>
      <ReferenceInput
        reference={administrationRequests.getStructuralUnitsSelect()}
        source="structuralUnitId"
        filter={{ filterByUser: true }}
      >
        <AutoPickSelectInput
          source="structuralUnitId"
          label="Факултет"
          validate={required()}
          emptyText={false}
          onChange={() => setValue("specialityId", null)}
          onValueChange={v => handleParamChange("structuralUnitId", v)}
        />
      </ReferenceInput>
      {structuralUnitId && (
        <ReferenceInput
          source="specialityId"
          reference={administrationRequests.getSpecialitiesSelect()}
          filter={{ structuralUnitId }}
        >
          <AutoPickSelectInput
            source="specialityId"
            label="Специалност"
            optionText="name"
            optionValue="id"
            validate={[required()]}
            emptyText={false}
            onValueChange={v => handleParamChange("specialityId", v)}
          />
        </ReferenceInput>
      )}
      {structuralUnitId && specialityId && (
        <ReferenceInput
          source="disciplineId"
          reference={studentRequests.getCurriculumsDisciplinesSelect()}
          filter={{ SpecialtyId: specialityId }}
        >
          <SelectInput
            label="Дисциплина"
            validate={required()}
            emptyText={false}
            onChange={e => handleParamChange("disciplineId", e.target.value)}
          />
        </ReferenceInput>
      )}
    </>
  );
};

export default SessionStartUnpassedExamsCount;
